var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-picker-option"},[_c('div',{staticClass:"calendar-picker-option__color-indicator",style:({ backgroundColor: _vm.color })}),_vm._v(" "),_c('span',{staticClass:"calendar-picker-option__label"},[_vm._v("\n\t\t"+_vm._s(_vm.displayname)+"\n\t")]),_vm._v(" "),_c('span',{class:_vm.displayIcon ? 'icon-caret-dark' : ''})])
}
var staticRenderFns = []

export { render, staticRenderFns }